import React from 'react';
import './TopBar.css';

const TopBar: React.FC = () => {
  return (
    <div className="top-bar">
      <div className="container">
        <div className="top-bar-left">
          <span><i className="fas fa-envelope"></i> trantrungg7@gmail.com</span>
          <span><i className="fas fa-phone"></i> 0702481111</span>
        </div>
        <div className="top-bar-right">
          <a href="https://www.google.com/maps/place/M%C6%A1+Nails/@10.8422427,106.6589741,16.75z/data=!4m6!3m5!1s0x317529004f2ef75d:0x2df16174e77a8259!8m2!3d10.8456239!4d106.6619725!16s%2Fg%2F11ypsfbglx?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">Vị trí cửa hàng</a>
          <a href="#track">Theo dõi đơn hàng</a>
          <select>
            <option>VND</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default TopBar;

